// extracted by mini-css-extract-plugin
export default {"container":"qDAFRc","text":"e0Iggh","buttonContainer":"CVeNtI"};